// ConfirmDialog — required gate for destructive actions (Frontend Rules §12:
// confirm every delete/reject/terminate, showing the entity name + the
// consequence). Built on Modal. Not for optimistic toggles — only irreversible
// or high-stakes actions.
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal } from './Modal';
import { Spinner } from '../feedback/Spinner';
import './confirm-dialog.css';

export function ConfirmDialog({
  open,
  title,
  message,
  entity,
  consequence,
  confirmLabel,
  cancelLabel,
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title ?? t('reusable.confirmDialog.title')}
      size="sm"
      actions={
        <>
          <button type="button" className="confirm-dialog__cancel" onClick={onCancel} disabled={loading}>
            {cancelLabel ?? t('reusable.confirmDialog.cancel')}
          </button>
          <button
            type="button"
            className={danger ? 'confirm-dialog__confirm is-danger' : 'confirm-dialog__confirm'}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? <Spinner size="sm" /> : (confirmLabel ?? t('reusable.confirmDialog.confirm'))}
          </button>
        </>
      }
    >
      {message && <p className="confirm-dialog__message">{message}</p>}
      {entity && <p className="confirm-dialog__entity">{entity}</p>}
      {consequence && <p className="confirm-dialog__consequence">{consequence}</p>}
    </Modal>
  );
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.node,
  message: PropTypes.node,
  /** The named thing being acted on (shown emphasized). */
  entity: PropTypes.node,
  /** What will happen as a result (shown as a warning line). */
  consequence: PropTypes.node,
  confirmLabel: PropTypes.node,
  cancelLabel: PropTypes.node,
  danger: PropTypes.bool,
  loading: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmDialog;
